import React, { SyntheticEvent } from 'react';
import { Input, TextArea, TextSelect } from '@app/form';
import { ParticipantField, ParticipantFieldType } from '@app/api';
import { ComponentProps, FormInputType } from './FormInputType';

const InputAdapter = ({
  field,
  onChange,
  ...props
}: ComponentProps<string>) => (
  <Input
    {...props}
    onChange={(e: SyntheticEvent<HTMLInputElement>) =>
      onChange(e.currentTarget.value)
    }
  />
);
const TextAreaAdapter = (props: ComponentProps<string>) => (
  <TextArea
    {...props}
    onChange={(e: SyntheticEvent<HTMLTextAreaElement>) =>
      props.onChange && props.onChange(e.currentTarget.value)
    }
  />
);

const SelectAdapter = ({ field, ...props }: ComponentProps<string>) => (
  <TextSelect {...props} options={field.choices} />
);

const textFieldInputMap: Record<
  ParticipantFieldType,
  FormInputType<string> | null
> = {
  [ParticipantFieldType.EMAIL]: InputAdapter,
  [ParticipantFieldType.PHONE_NUMBER]: InputAdapter,
  [ParticipantFieldType.SINGLE_CHOICE]: SelectAdapter,
  [ParticipantFieldType.MULTIPLE_CHOICE]: SelectAdapter,
  [ParticipantFieldType.TAGS]: null,
  [ParticipantFieldType.SHORT_TEXT]: InputAdapter,
  [ParticipantFieldType.LONG_TEXT]: TextAreaAdapter,
  [ParticipantFieldType.DATE]: null,
  [ParticipantFieldType.NUMBER]: InputAdapter,
  [ParticipantFieldType.GEOLOCATION]: InputAdapter,
  [ParticipantFieldType.INCOME]: SelectAdapter,
  [ParticipantFieldType.TIMEZONE]: InputAdapter,
  [ParticipantFieldType.LOCALES]: SelectAdapter,
  [ParticipantFieldType.BOOLEAN]: null,
};

export const getParticipantTextFieldInput = (
  field: ParticipantField,
): FormInputType<string> | null => {
  return textFieldInputMap[field.type];
};
